import React from 'react';
import { useDrop } from 'react-dnd';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { Types } from '../../Types/';
import { addQuestion } from '../../../../../_actions/questionnaire.actions';

import DateType from './Types/DateType';
import ChoiceType from './Types/ChoiceType';
import DisplayType from './Types/DisplayType';
import LongTextType from './Types/LongTextType';
import OpenChoiceType from './Types/OpenChoiceType';
import AttachmentType from './Types/AttachmentType';
import ShortTextType from './Types/ShortTextType';
import YesNoType from './Types/YesNoType'
import IntegerType from './Types/IntegerType';
import Empty from './Types/Empty';

import './styles.css';

const CanvasContainer = ({ title, items = [], dispatch }) => {
  const [{ canDrop }, drop] = useDrop({
    accept: Types,
    drop: (item, monitor) => {
      if (monitor.didDrop()) {
        return;
      }

      dispatch(addQuestion(item.question.resource));
    },
    collect: (monitor) => ({
      canDrop: monitor.canDrop() && monitor.isOver({ shallow: true }),
    })
  });

  const canDropStyle = classNames('questionnaire-canvas-body', 'p-3', {
    active: canDrop
  });

  return (
    <div className="questionnaire-canvas">
      <div className="questionnaire-canvas-header col mb-2">
        <h5 style={{ borderBottom: '4px solid #1AB2E9' }}>Questions</h5>
      </div>

      <div
        ref={drop}
        className={canDropStyle}>

        {items.length === 0 &&
          <Empty />
        }

        {items.length > 0 && items.map((item, index) => {
          switch (item.type) {
            case 'date':
              return <DateType key={item.linkId} index={index} question={item} />;
            case 'choice':
              return <ChoiceType key={item.linkId} index={index} question={item} />;
            case 'open-choice':
              return <OpenChoiceType key={item.linkId} index={index} question={item} />;
            case 'string':
              return <ShortTextType key={item.linkId} index={index} question={item} />;
            case 'text':
              return <LongTextType key={item.linkId} index={index} question={item} />;
            case 'boolean':
              return <YesNoType key={item.linkId} index={index} question={item} />;
            case 'display':
              return <DisplayType key={item.linkId} index={index} question={item} />;
            case 'attachment':
              return <AttachmentType key={item.linkId} index={index} question={item} />;
            case 'integer':
              return <IntegerType key={item.linkId} index={index} question={item} />;
            default:
              return false;
          }
        })}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    title: state.questionnaire.current.title,
    items: state.questionnaire.current.item
  }
}

const Canvas = connect(mapStateToProps)(CanvasContainer);

export default Canvas;
